/*-----------------------------------AUTHENTICATE-USER-----------------------------------*/
export const AUTHENTICATE_USER = "AUTHENTICATE_USER";
export const AUTHENTICATE_USER_SUCCESS = "AUTHENTICATE_USER_SUCCESS";
export const AUTHENTICATE_USER_FAILURE = "AUTHENTICATE_USER_FAILURE";
export const SET_IS_AUTHENTICATED = "SET_IS_AUTHENTICATED";
/*-----------------------------------REGISTER-MFA-USER-----------------------------------*/
export const REGISTER_MFA = "REGISTER_MFA";
export const REGISTER_MFA_SUCCESS = "REGISTER_MFA_SUCCESS";
export const REGISTER_MFA_FAILURE = "REGISTER_MFA_FAILURE";
/*-----------------------------------SEND-OTP-MAIL-----------------------------------*/
export const SEND_OTP_MAIL = "SEND_OTP_MAIL";
export const SEND_OTP_MAIL_SUCCESS = "SEND_OTP_MAIL_SUCCESS";
export const SEND_OTP_MAIL_FAILURE = "SEND_OTP_MAIL_FAILURE";
/*----------------------------------POST-CHANGE-PASSWORD---------------------------------*/
export const POST_CHANGE_PASSWORD = "POST_CHANGE_PASSWORD";
export const POST_CHANGE_PASSWORD_SUCCESS = "POST_CHANGE_PASSWORD_SUCCESS";
export const POST_CHANGE_PASSWORD_FAILURE = "POST_CHANGE_PASSWORD_FAILURE";

/*----------------------------------CLEAR-CHANGE-PASSWORD---------------------------------*/
export const CLEAR_CHANGE_PASSWORD = "CLEAR_CHANGE_PASSWORD";

/*-----------------------------------RESET-STATE-----------------------------------*/
export const RESET_ERROR = "RESET_ERROR";

/*-----------------------------------FETCH-CATEGORIES-----------------------------------*/
export const FETCH_CATEGORIES = "FETCH_CATEGORIES";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_FAILURE = "FETCH_CATEGORIES_FAILURE";

/*-----------------------------------RESET-STATE-----------------------------------*/
export const RESET_STATE = "RESET_STATE";

/*----------------------------------FETCH-TYPE-DECISION----------------------------------*/
export const FETCH_TYPE_DECISION = "FETCH_TYPE_DECISION";
export const FETCH_TYPE_DECISION_SUCCESS = "FETCH_TYPE_DECISION_SUCCESS";
export const FETCH_TYPE_DECISION_FAILURE = "FETCH_TYPE_DECISION_FAILURE";

/*----------------------------------FETCH-UNIT-COMP----------------------------------*/
export const FETCH_UNIT_COMP = "FETCH_UNIT_COMP";
export const FETCH_UNIT_COMP_SUCCESS = "FETCH_UNIT_COMP_SUCCESS";
export const FETCH_UNIT_COMP_FAILURE = "FETCH_UNIT_COMP_FAILURE";

/*----------------------------------FETCH-UNIT-DOUNIERE----------------------------------*/
export const FETCH_TYPE_DOUNIERE = "FETCH_TYPE_DOUNIERE";
export const FETCH_TYPE_DOUNIERE_SUCCESS = "FETCH_TYPE_DOUNIERE_SUCCESS";
export const FETCH_TYPE_DOUNIERE_FAILURE = "FETCH_TYPE_DOUNIERE_FAILURE";

/*----------------------------------FETCH-DEPARTMENTS----------------------------------*/
export const FETCH_DEPARTMENTS = "FETCH_DEPARTMENTS";
export const FETCH_DEPARTMENTS_SUCCESS = "FETCH_DEPARTMENTS_SUCCESS";
export const FETCH_DEPARTMENTS_FAILURE = "FETCH_DEPARTMENTS_FAILURE";

/*----------------------------------SELECTED-DEPARTMENT----------------------------------*/
export const SELECTED_DEPARTMENT = "SELECTED_DEPARTMENT";
export const SELECTED_DEPARTMENT_SUCCESS = "SELECTED_DEPARTMENT_SUCCESS";
export const SELECTED_DEPARTMENT_FAILURE = "SELECTED_DEPARTMENT_FAILURE";

/*-----------------------------------SET-DECISION-MODE-----------------------------------*/
export const SET_DECISION_MODE = "SET_DECISION_MODE";

/*-----------------------------------CLEAR-DEMANDE-DETIALS-----------------------------------*/
export const CLEAR_DEMANDE_DETIALS = "CLEAR_DEMANDE_DETIALS";

/*-----------------------------------CLEAR-SEARCH-FORM-----------------------------------*/
export const CLEAR_SEARCH_FORM = "CLEAR_DEMANDE_FORM";

/**************************************************************************************************************/

/* ------------------------------------ LE -------------------------------------------- */

/*----------------------------------DOWNLOAD-FACTURE-DOCUMENT----------------------------------*/
export const DOWNLOAD_FACTURE_DOCUMENT = "DOWNLOAD_FACTURE_DOCUMENT";
export const DOWNLOAD_FACTURE_DOCUMENT_SUCCESS =
  "DOWNLOAD_FACTURE_DOCUMENT_SUCCESS";
export const DOWNLOAD_FACTURE_DOCUMENT_FAILURE =
  "DOWNLOAD_FACTURE_DOCUMENT_FAILURE";

/*-----------------------------------FETCH-DEVISE-----------------------------------*/
export const FETCH_DEVISE = "FETCH_DEVISE";
export const FETCH_DEVISE_SUCCESS = "FETCH_DEVISE_SUCCESS";
export const FETCH_DEVISE_FAILURE = "FETCH_DEVISE_FAILURE";

/*----------------------------------FETCH-MODE-PAIEMENT----------------------------------*/
export const FETCH_MODE_PAIEMENT = "FETCH_MODE_PAIEMENT";
export const FETCH_MODE_PAIEMENT_SUCCESS = "FETCH_MODE_PAIEMENT_SUCCESS";
export const FETCH_MODE_PAIEMENT_FAILURE = "FETCH_MODE_PAIEMENT_FAILURE";

/*----------------------------------FETCH-INCOTERM----------------------------------*/
export const FETCH_INCOTERM = "FETCH_INCOTERM";
export const FETCH_INCOTERM_SUCCESS = "FETCH_INCOTERM_SUCCESS";
export const FETCH_INCOTERM_FAILURE = "FETCH_INCOTERM_FAILURE";

/*----------------------------------FETCH-REGIME-DOUANIER----------------------------------*/
export const FETCH_REGIME_DOUANIER = "FETCH_REGIME_DOUANIER";
export const FETCH_REGIME_DOUANIER_SUCCESS = "FETCH_REGIME_DOUANIER_SUCCESS";
export const FETCH_REGIME_DOUANIER_FAILURE = "FETCH_REGIME_DOUANIER_FAILURE";

/*----------------------------------FETCH-BUREAU-DOUANIER----------------------------------*/
export const FETCH_BUREAU_DOUANIER = "FETCH_BUREAU_DOUANIER";
export const FETCH_BUREAU_DOUANIER_SUCCESS = "FETCH_BUREAU_DOUANIER_SUCCESS";
export const FETCH_BUREAU_DOUANIER_FAILURE = "FETCH_BUREAU_DOUANIER_FAILURE";

/*----------------------------------FETCH-EXPORTATEURS----------------------------------*/
export const FETCH_EXPORTATEURS = "FETCH_EXPORTATEURS";
export const FETCH_EXPORTATEURS_SUCCESS = "FETCH_EXPORTATEURS_SUCCESS";
export const FETCH_EXPORTATEURS_FAILURE = "FETCH_EXPORTATEURS_FAILURE";

/*----------------------------------FETCH-DECLARANT----------------------------------*/
export const FETCH_DECLARANT = "FETCH_DECLARANT";
export const FETCH_DECLARANT_SUCCESS = "FETCH_DECLARANT_SUCCESS";
export const FETCH_DECLARANT_FAILURE = "FETCH_DECLARANT_FAILURE";

/*-----------------------------------FETCH-TYPE-TI-----------------------------------*/
export const FETCH_TYPE_TI = "FETCH_TYPE_TI";
export const FETCH_TYPE_TI_SUCCESS = "FETCH_TYPE_TI_SUCCESS";
export const FETCH_TYPE_TI_FAILURE = "FETCH_TYPE_TI_FAILURE";

/*-----------------------------------FETCH-TYPE-TE-----------------------------------*/
export const FETCH_TYPE_TE = "FETCH_TYPE_TE";
export const FETCH_TYPE_TE_SUCCESS = "FETCH_TYPE_TE_SUCCESS";
export const FETCH_TYPE_TE_FAILURE = "FETCH_TYPE_TE_FAILURE";

/*----------------------------------FETCH-TYPE-DECISION-LE----------------------------------*/
export const FETCH_TYPE_DECISION_LE = "FETCH_TYPE_DECISION_LE";
export const FETCH_TYPE_DECISION_LE_SUCCESS = "FETCH_TYPE_DECISION_LE_SUCCESS";
export const FETCH_TYPE_DECISION_LE_FAILURE = "FETCH_TYPE_DECISION_LE_FAILURE";

/*----------------------------------FETCH-DEPARTMENTS----------------------------------*/
export const FETCH_DEPARTMENTS_LE = "FETCH_DEPARTMENTS_LE";
export const FETCH_DEPARTMENTS_LE_SUCCESS = "FETCH_DEPARTMENTS_LE_SUCCESS";
export const FETCH_DEPARTMENTS_LE_FAILURE = "FETCH_DEPARTMENTS_LE_FAILURE";

/*----------------------------------GET-AUTHORITIES----------------------------------*/
export const GET_AUTHORITIES = "GET_AUTHORITIES";
export const GET_AUTHORITIES_SUCCESS = "GET_AUTHORITIES_SUCCESS";
export const GET_AUTHORITIES_FAILURE = "GET_AUTHORITIES_FAILURE";

/*----------------------------------CAN-TAKE-DECISION----------------------------------*/
export const CAN_TAKE_DECISION = "CAN_TAKE_DECISION";
export const CAN_TAKE_DECISION_SUCCESS = "CAN_TAKE_DECISION_SUCCESS";
export const CAN_TAKE_DECISION_FAILURE = "CAN_TAKE_DECISION_FAILURE";

/*-----------------------------------SET-DECISION-VISIBLE-----------------------------------*/
export const SET_DECISION_VISIBLE = "SET_DECISION_VISIBLE";

/**************************************************************************************************************/

/* ------------------------------------ TI -------------------------------------------- */

/*-----------------------------------SEARCH-TITRE-----------------------------------*/
export const SEARCH_TITRE = "SEARCH_TITRE";
export const SEARCH_TITRE_SUCCESS = "SEARCH_TITRE_SUCCESS";
export const SEARCH_TITRE_FAILURE = "SEARCH_TITRE_FAILURE";

/*-----------------------------------FETCH-ALL-TITRES-----------------------------------*/
export const SEARCH_ALL_TITRES = "SEARCH_ALL_TITRES";
export const SEARCH_ALL_TITRES_SUCCESS = "SEARCH_ALL_TITRES_SUCCESS";
export const SEARCH_ALL_TITRES_FAILURE = "SEARCH_ALL_TITRES_FAILURE";

/*-----------------------------------CLEAR-TI-SEARCH-FORM-----------------------------------*/
export const CLEAR_TI_SEARCH_FORM = "CLEAR_TI_SEARCH_FORM";

/*-----------------------------------SET-TI-DECISION-MODE-----------------------------------*/
export const SET_TI_DECISION_MODE = "SET_TI_DECISION_MODE";

/*-----------------------------------FETCH-TI-IMPORTATEURS-----------------------------------*/
export const FETCH_TI_IMPORTATEURS = "FETCH_TI_IMPORTATEURS";
export const FETCH_TI_IMPORTATEURS_SUCCESS = "FETCH_TI_IMPORTATEURS_SUCCESS";
export const FETCH_TI_IMPORTATEURS_FAILURE = "FETCH_TI_IMPORTATEURS_FAILURE";

/*-----------------------------------FETCH-TI-NOMENCLATURES-----------------------------------*/
export const FETCH_TI_NOMENCLATURES = "FETCH_TI_NOMENCLATURES";
export const FETCH_TI_NOMENCLATURES_SUCCESS = "FETCH_TI_NOMENCLATURES_SUCCESS";
export const FETCH_TI_NOMENCLATURES_FAILURE = "FETCH_TI_NOMENCLATURES_FAILURE";

/*-----------------------------------FETCH-TI-GUICHETS-----------------------------------*/
export const FETCH_TI_GUICHETS = "FETCH_TI_GUICHETS";
export const FETCH_TI_GUICHETS_SUCCESS = "FETCH_TI_GUICHETS_SUCCESS";
export const FETCH_TI_GUICHETS_FAILURE = "FETCH_TI_GUICHETS_FAILURE";

/*----------------------------------FETCH-TI-DECLARANT----------------------------------*/
export const FETCH_TI_DECLARANTS = "FETCH_TI_DECLARANT";
export const FETCH_TI_DECLARANTS_SUCCESS = "FETCH_TI_DECLARANT_SUCCESS";
export const FETCH_TI_DECLARANTS_FAILURE = "FETCH_TI_DECLARANT_FAILURE";

/*-----------------------------------FETCH-TI-TYPE-TE-----------------------------------*/
export const FETCH_TI_TYPE_TE = "FETCH_TI_TYPE_TE";
export const FETCH_TI_TYPE_TE_SUCCESS = "FETCH_TI_TYPE_TE_SUCCESS";
export const FETCH_TI_TYPE_TE_FAILURE = "FETCH_TI_TYPE_TE_FAILURE";

/*-----------------------------------FETCH-TI-TYPE-TI-----------------------------------*/
export const FETCH_TI_TYPE_TI = "FETCH_TI_TYPE_TI";
export const FETCH_TI_TYPE_TI_SUCCESS = "FETCH_TI_TYPE_TI_SUCCESS";
export const FETCH_TI_TYPE_TI_FAILURE = "FETCH_TI_TYPE_TI_FAILURE";

/*-----------------------------------FETCH-TI-ETATS-----------------------------------*/
export const FETCH_TI_ETATS = "FETCH_TI_ETATS";
export const FETCH_TI_ETATS_SUCCESS = "FETCH_TI_ETATS_SUCCESS";
export const FETCH_TI_ETATS_FAILURE = "FETCH_TI_ETATS_FAILURE";

/*-----------------------------------FETCH-TI-LOCALITES-----------------------------------*/
export const FETCH_TI_LOCALITES = "FETCH_TI_LOCALITES";
export const FETCH_TI_LOCALITES_SUCCESS = "FETCH_TI_LOCALITES_SUCCESS";
export const FETCH_TI_LOCALITES_FAILURE = "FETCH_TI_LOCALITES_FAILURE";

/*-----------------------------------FETCH-TI-CATEGORIES-----------------------------------*/
export const FETCH_TI_CATEGORIES = "FETCH_TI_CATEGORIES";
export const FETCH_TI_CATEGORIES_SUCCESS = "FETCH_TI_CATEGORIES_SUCCESS";
export const FETCH_TI_CATEGORIES_FAILURE = "FETCH_TI_CATEGORIES_FAILURE";

/*-----------------------------------FETCH-TI-STATUS-MODIF-----------------------------------*/
export const FETCH_TI_STATUS_MODIF = "FETCH_TI_STATUS_MODIF";
export const FETCH_TI_STATUS_MODIF_SUCCESS = "FETCH_TI_STATUS_MODIF_SUCCESS";
export const FETCH_TI_STATUS_MODIF_FAILURE = "FETCH_TI_STATUS_MODIF_FAILURE";

/*-----------------------------------FETCH-TI-TYPE-MESSAGE-----------------------------------*/
export const FETCH_TI_TYPE_MESSAGE = "FETCH_TI_TYPE_MESSAGE";
export const FETCH_TI_TYPE_MESSAGE_SUCCESS = "FETCH_TI_TYPE_MESSAGE_SUCCESS";
export const FETCH_TI_TYPE_MESSAGE_FAILURE = "FETCH_TI_TYPE_MESSAGE_FAILURE";

/*-----------------------------------FETCH-TI-BANQUE-----------------------------------*/
export const FETCH_TI_BANQUE = "FETCH_TI_BANQUE";
export const FETCH_TI_BANQUE_SUCCESS = "FETCH_TI_BANQUE_SUCCESS";
export const FETCH_TI_BANQUE_FAILURE = "FETCH_TI_BANQUE_FAILURE";

/*-----------------------------------FETCH-TYPE-REGLEMENT-----------------------------------*/
export const FETCH_TYPE_REGLEMENT = "FETCH_TYPE_REGLEMENT";
export const FETCH_TYPE_REGLEMENT_SUCCESS = "FETCH_TYPE_REGLEMENT_SUCCESS";
export const FETCH_TYPE_REGLEMENT_FAILURE = "FETCH_TYPE_REGLEMENT_FAILURE";

/*-----------------------------------FETCH-MODE-REGLEMENT-----------------------------------*/
export const FETCH_MODE_REGLEMENT = "FETCH_MODE_REGLEMENT";
export const FETCH_MODE_REGLEMENT_SUCCESS = "FETCH_MODE_REGLEMENT_SUCCESS";
export const FETCH_MODE_REGLEMENT_FAILURE = "FETCH_MODE_REGLEMENT_FAILURE";

/*-----------------------------------FETCH-TI-APUREMENT-----------------------------------*/
export const FETCH_TI_APUREMENT = "FETCH_TI_APUREMENT";
export const FETCH_TI_APUREMENT_SUCCESS = "FETCH_TI_APUREMENT_SUCCESS";
export const FETCH_TI_APUREMENT_FAILURE = "FETCH_TI_APUREMENT_FAILURE";

/*----------------------------------------FETCH-LE----------------------------------------*/
export const FETCH_TI = "FETCH_TI";
export const FETCH_TI_SUCCESS = "FETCH_TI_SUCCESS";
export const FETCH_TI_FAILURE = "FETCH_TI_FAILURE";

/*-----------------------------------SET-DECISION-lE-VISIBLE-----------------------------------*/
export const SET_DECISION_TI_VISIBLE = "SET_DECISION_TI_VISIBLE";

/*----------------------------------DOWNLOAD-LE----------------------------------*/
export const DOWNLOAD_TI = "DOWNLOAD_TI";
export const DOWNLOAD_TI_SUCCESS = "DOWNLOAD_TI_SUCCESS";
export const DOWNLOAD_TI_FAILURE = "DOWNLOAD_TI_FAILURE";

/*----------------------------------DOWNLOAD-FACTURE-DOCUMENT----------------------------------*/
export const DOWNLOAD_TI_FACTURE_DOCUMENT = "DOWNLOAD_TI_FACTURE_DOCUMENT";
export const DOWNLOAD_TI_FACTURE_DOCUMENT_SUCCESS =
  "DOWNLOAD_TI_FACTURE_DOCUMENT_SUCCESS";
export const DOWNLOAD_TI_FACTURE_DOCUMENT_FAILURE =
  "DOWNLOAD_TI_FACTURE_DOCUMENT_FAILURE";

/*----------------------------------DOWNLOAD-LE-DOCUMENT----------------------------------*/
export const DOWNLOAD_TI_DOCUMENT = "DOWNLOAD_TI_DOCUMENT";
export const DOWNLOAD_TI_DOCUMENT_SUCCESS = "DOWNLOAD_TI_DOCUMENT_SUCCESS";
export const DOWNLOAD_TI_DOCUMENT_FAILURE = "DOWNLOAD_TI_DOCUMENT_FAILURE";

/*-----------------------------------CLEAR-TITRE-DETIALS-----------------------------------*/
export const CLEAR_TITRE_DETIALS = "CLEAR_TITRE_DETIALS";

/*-----------------------------------CLEAR-TITRE-ERROR-----------------------------------*/
export const CLEAR_TITRE_ERROR = "CLEAR_TITRE_ERROR";

/*-----------------------------------FETCH-TI-HISTORIQUE-----------------------------------*/
export const FETCH_HISTORIQUE_TI = "FETCH_HISTORIQUE_TI";
export const FETCH_HISTORIQUE_TI_SUCCESS = "FETCH_HISTORIQUE_TI_SUCCESS";
export const FETCH_HISTORIQUE_TI_FAILURE = "FETCH_HISTORIQUE_TI_FAILURE";

/*-----------------------------------FETCH-TI-HISTORIQUE-----------------------------------*/
export const CLEAR_HISTORIQUE_TI = "CLEAR_HISTORIQUE_TI";

/*----------------------------------FETCH-DEPARTMENTS----------------------------------*/
export const FETCH_DEPARTMENTS_TI = "FETCH_DEPARTMENTS_TI";
export const FETCH_DEPARTMENTS_TI_SUCCESS = "FETCH_DEPARTMENTS_TI_SUCCESS";
export const FETCH_DEPARTMENTS_TI_FAILURE = "FETCH_DEPARTMENTS_TI_FAILURE";

/*----------------------------------TRANSFER-TI----------------------------------*/
export const TRANSFER_TI = "TRANSFER_TI";
export const TRANSFER_TI_SUCCESS = "TRANSFER_TI_SUCCESS";
export const TRANSFER_TI_FAILURE = "TRANSFER_TI_FAILURE";

/*----------------------------------TRANSFER-TI-PROLONG----------------------------------*/
export const TRANSFER_TI_PROLONG = "TRANSFER_TI_PROLONG";
export const TRANSFER_TI_PROLONG_SUCCESS = "TRANSFER_TI_PROLONG_SUCCESS";
export const TRANSFER_TI_PROLONG_FAILURE = "TRANSFER_TI_PROLONG_FAILURE";

/*----------------------------------FETCH-TI-TYPE-DECISION-----------------------------------*/
export const FETCH_TI_TYPE_DECISION_MCE = "FETCH_TI_TYPE_DECISION_MCE";
export const FETCH_TI_TYPE_DECISION_MCE_SUCCESS =
  "FETCH_TI_TYPE_DECISION_MCE_SUCCESS";
export const FETCH_TI_TYPE_DECISION_MCE_FAILURE =
  "FETCH_TI_TYPE_DECISION_MCE_FAILURE";

/*-----------------------------------POST-TI-DECISION-MCE---------------------------------*/
export const POST_TI_DECISION_MCE = "POST_TI_DECISION_MCE";
export const POST_TI_DECISION_MCE_SUCCESS = "POST_TI_DECISION_MCE_SUCCESS";
export const POST_TI_DECISION_MCE_FAILURE = "POST_TI_DECISION_MCE_FAILURE";

/*-----------------------------------POST-TI-DECISION-DEP---------------------------------*/
export const POST_TI_DECISION_DEP = "POST_TI_DECISION_DEP";
export const POST_TI_DECISION_DEP_SUCCESS = "POST_TI_DECISION_DEP_SUCCESS";
export const POST_TI_DECISION_DEP_FAILURE = "POST_TI_DECISION_DEP_FAILURE";

/*-----------------------------------POST-TI-TYPE-DECISION-MCE-PROLONG--------------------------------*/
export const FETCH_TI_TYPE_DECISION_MCE_PROLONG =
  "FETCH_TI_TYPE_DECISION_MCE_PROLONG";
export const FETCH_TI_TYPE_DECISION_MCE_PROLONG_SUCCESS =
  "FETCH_TI_TYPE_DECISION_MCE_PROLONG_SUCCESS";
export const FETCH_TI_TYPE_DECISION_MCE_PROLONG_FAILURE =
  "FETCH_TI_TYPE_DECISION_MCE_PROLONG_FAILURE";

/*-----------------------------------POST-TI-PROLONG-MCE--------------------------------*/
export const POST_TI_PROLONG_MCE = "POST_TI_PROLONG_MCE";
export const POST_TI_PROLONG_MCE_SUCCESS = "POST_TI_PROLONG_MCE_SUCCESS";
export const POST_TI_PROLONG_MCE_FAILURE = "POST_TI_PROLONG_MCE_FAILURE";

/*-----------------------------------POST-TI-PROLONG-DEP---------------------------------*/
export const POST_TI_PROLONG_DEP = "POST_TI_PROLONG_DEP";
export const POST_TI_PROLONG_DEP_SUCCESS = "POST_TI_PROLONG_DEP_SUCCESS";
export const POST_TI_PROLONG_DEP_FAILURE = "POST_TI_PROLONG_DEP_FAILURE";

/*-----------------------------------SET-TI-COLUMNS-STATE-----------------------------------*/
export const SET_TI_COLUMNS_DENSITY_STATE = "SET_TI_COLUMNS_DENSITY_STATE";

/*-----------------------------------GET-TI-COLUMNS-STATE-----------------------------------*/
export const GET_TI_COLUMNS_DENSITY_STATE = "GET_TI_COLUMNS_DENSITY_STATE";
export const GET_TI_COLUMNS_DENSITY_STATE_SUCCESS =
  "GET_TI_COLUMNS_DENSITY_STATE_SUCCESS";
export const GET_TI_COLUMNS_DENSITY_STATE_FAILURE =
  "GET_TI_COLUMNS_DENSITY_STATE_FAILURE";

/*-----------------------------------POST-DONNEES-REGLEMENT---------------------------------*/
export const POST_DONNEES_REGLEMENT = "POST_DONNEES_REGLEMENT";
export const POST_DONNEES_REGLEMENT_SUCCESS = "POST_DONNEES_REGLEMENT_SUCCESS";
export const POST_DONNEES_REGLEMENT_FAILURE = "POST_DONNEES_REGLEMENT_FAILURE";

/*-----------------------------------SET_DRAWER_STATE---------------------------------*/
export const SET_DRAWER_STATE = "SET_DRAWER_STATE";

/**************************************************************************************************************/

/* ------------------------------------ DASHBOARD -------------------------------------------- */

/*-----------------------------------------TI-KPI-----------------------------------------*/
export const TI_KPI = "TI_KPI";
export const TI_KPI_SUCCESS = "TI_KPI_SUCCESS";
export const TI_KPI_FAILURE = "TI_KPI_FAILURE";
/*-------------------------------GET-REPONSE-DOMICILIATION-BANQUE-DATA-----------------*/
export const GET_REPONSE_DOMICILIATION_BANQUE_DATA =
  "GET_REPONSE_DOMICILIATION_BANQUE_DATA";
export const GET_REPONSE_DOMICILIATION_BANQUE_DATA_SUCCESS =
  "GET_REPONSE_DOMICILIATION_BANQUE_DATA_SUCCESS";
export const GET_REPONSE_DOMICILIATION_BANQUE_DATA_FAIL =
  "GET_REPONSE_DOMICILIATION_BANQUE_DATA_FAIL";
/*-------------------------------ACCEPT-DOMICILIATION-BANQUE-----------------*/
export const ACCEPT_DOMICILIATION_BANQUE = "ACCEPT_DOMICILIATION_BANQUE";
export const ACCEPT_DOMICILIATION_BANQUE_SUCCESS =
  "ACCEPT_DOMICILIATION_BANQUE_SUCCESS";
export const ACCEPT_DOMICILIATION_BANQUE_FAIL =
  "ACCEPT_DOMICILIATION_BANQUE_FAIL";

export const ACCEPT_DOMICILIATION_BANQUE_REINITIALIZATION =
  "ACCEPT_DOMICILIATION_BANQUE_REINITIALIZATION";
/*-------------------------------REFUSE-DOMICILIATION-BANQUE-----------------*/
export const REFUSE_DOMICILIATION_BANQUE = "REFUSE_DOMICILIATION_BANQUE";
export const REFUSE_DOMICILIATION_BANQUE_SUCCESS =
  "REFUSE_DOMICILIATION_BANQUE_SUCCESS";
export const REFUSE_DOMICILIATION_BANQUE_FAIL =
  "REFUSE_DOMICILIATION_BANQUE_FAIL";
export const REFUSE_DOMICILIATION_BANQUE_REINITIALIZATION =
  "REFUSE_DOMICILIATION_BANQUE_REINITIALIZATION";

/*-----------------------------SET_CONSULTING_MODE-----------------------------*/
export const SET_CONSULTING_MODE = "SET_CONSULTING_MODE";
